export default {
  secretmanager: 'Secrets Manager',
  papservice: 'Profile Service',
  accessrequest: 'Access Request',
}
